import {ProjectColors} from "../../../Enums/Core/projectColors";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React, {useState} from "react";

export default function WaterConsumptionAndAlertsCharts(props) {
    const [showConsumption, setShowConsumption] = useState(true);
    const [showAlerts, setShowAlerts] = useState(true);

    const options = {
        legend: {
            itemStyle: {
                lineHeight: "20px", fontSize: '15px'
            }, symbolHeight: 17, useHTML: true,
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: props.categories, crosshair: true, labels: {
                rotation: props.resolution === 2 ? -45 : 0, style: {
                    whiteSpace: 'nowrap'
                }
            }
        },
        yAxis: [{
            title: {
                text: 'Water Consumption'
            }
        }, {
            title: {
                text: 'Alerts', style: {
                    color: ProjectColors.DarkRed
                }
            }, labels: {
                style: {
                    color: ProjectColors.DarkRed
                }
            }, opposite: true
        }],
        tooltip: {
            shared: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2, borderWidth: 0
            }, series: {
                events: {
                    click: function (event) {
                        if (props.onClick) {
                            props.onClick(event);
                        }
                    }, legendItemClick() {
                        if (this.userOptions.id === 'alerts') {
                            setShowAlerts(!showAlerts);
                            this.chart.series.forEach((series) => {
                                if (series.initialType === 'line' && series.userOptions.id !== "consumption") {
                                    if (series.visible) {
                                        series.hide();
                                        series.visibility = false;
                                    } else {
                                        series.show();
                                        series.visibility = true;
                                    }
                                }
                            })
                        } else if (this.userOptions.id === 'consumption') {
                            setShowConsumption(!showConsumption);
                            this.chart.series.forEach((series) => {
                                if (series.initialType === 'column') {
                                    if (series.visible) {
                                        series.hide();
                                        series.visibility = false;
                                    } else {
                                        series.show();
                                        series.visibility = true;
                                    }
                                }
                            })
                        }
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [{
            name: 'Alerts', id: 'alerts', visibility: showAlerts, marker: {
                symbol: showAlerts ? "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGZSURBVFhH7ZgxTgMxEEXpaDkCR+AEiCPkCBwBCVHQICralNCRhoIOQccVQJCCngpKoIJy4Cu2FM9+e8fGllzsk74UJd7xi/cX2WxIp0xiuVCxqyeR3XORzeO/BUd1g5mYjT1SDMQO74bDWgV7xQjE8C3YgJaJnVwghiNmF7cM9mQEYi06tXUisjPnnyHYkxGIsQv/m5uX1ez9a/45wmgqdnrvBjsuH/g6RjOx2cINVSweh2sZTcTQqc9vN3SNrx+R7bPhekZ1MZT9+c0NVOxd8GsY1cV82TUHt3w9wqgqpsvuYb1aD6OaWKzsy/fV7WXX+DDMYjiN2Aa5ZddhmMRwKwBKreVKyq7DGBXzUh4tV1J2HUZSLFZmL1dadh1GUgybo7yM1w/3QmEpuw5j9Fam5DTWsuswTOW3ylnLrsMwiSFjcjll12GYxZCYXG7ZdRhZYoiWw2u8x9Zaw8gWQ7xcadl1GEViCORSv+VzwgjEWjyMjMX0MNLt41u3D7ygy78IPPgWOOIWncNMzI6dlIeK9cAklssklofILxLpAcng1g3BAAAAAElFTkSuQmCC)" : "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC3SURBVFhH7ZcxCgQhDEXn1BZexIt4BluvY5flw6YZooHRZTPwH6QSv89gES8JBoU83iXUe5dSiuScJaW0VchAFjJXTIVqrWbwiUL2DFMIt9DNrTUZY3xXnoMMZGnurFOmEFqrMqdRKZxhYQrpmznRmTvIRDbOsDCFsAH1K1b5FAIU8qCQB4U8KORBIQ8KebxfKNyAFm6EDTfkg1DfIAW3QGv1Te0UMpA164yyFPoHFPKgkEcwIZEPqQkOLhzsosMAAAAASUVORK5CYII=)"
            }, color: 'white', squareSymbol: true
        }, {
            name: 'Consumption', id: 'consumption', lineWidth: 10, visibility: showConsumption, marker: {
                symbol: showConsumption ? "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGZSURBVFhH7ZgxTgMxEEXpaDkCR+AEiCPkCBwBCVHQICralNCRhoIOQccVQJCCngpKoIJy4Cu2FM9+e8fGllzsk74UJd7xi/cX2WxIp0xiuVCxqyeR3XORzeO/BUd1g5mYjT1SDMQO74bDWgV7xQjE8C3YgJaJnVwghiNmF7cM9mQEYi06tXUisjPnnyHYkxGIsQv/m5uX1ez9a/45wmgqdnrvBjsuH/g6RjOx2cINVSweh2sZTcTQqc9vN3SNrx+R7bPhekZ1MZT9+c0NVOxd8GsY1cV82TUHt3w9wqgqpsvuYb1aD6OaWKzsy/fV7WXX+DDMYjiN2Aa5ZddhmMRwKwBKreVKyq7DGBXzUh4tV1J2HUZSLFZmL1dadh1GUgybo7yM1w/3QmEpuw5j9Fam5DTWsuswTOW3ylnLrsMwiSFjcjll12GYxZCYXG7ZdRhZYoiWw2u8x9Zaw8gWQ7xcadl1GEViCORSv+VzwgjEWjyMjMX0MNLt41u3D7ygy78IPPgWOOIWncNMzI6dlIeK9cAklssklofILxLpAcng1g3BAAAAAElFTkSuQmCC)" : "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC3SURBVFhH7ZcxCgQhDEXn1BZexIt4BluvY5flw6YZooHRZTPwH6QSv89gES8JBoU83iXUe5dSiuScJaW0VchAFjJXTIVqrWbwiUL2DFMIt9DNrTUZY3xXnoMMZGnurFOmEFqrMqdRKZxhYQrpmznRmTvIRDbOsDCFsAH1K1b5FAIU8qCQB4U8KORBIQ8KebxfKNyAFm6EDTfkg1DfIAW3QGv1Te0UMpA164yyFPoHFPKgkEcwIZEPqQkOLhzsosMAAAAASUVORK5CYII=)"
            }, color: 'white'

        }].concat(props.data.map(series => {
            return {
                type: 'column', name: series.name, data: series.consumptionData, color: series.color, tooltip: {
                    valueSuffix: ` ${props.volumeUnit}`
                }, showInLegend: true
            }
        }).concat(props.data.map(series => {
            return {
                type: 'line',
                name: `${series.name} Alerts`,
                data: series.leakAlerts,
                color: 'red',
                yAxis: 1,
                showInLegend: false,
                marginLeft: 500
            }
        })))
    };

    return (<HighchartsReact
        highcharts={Highcharts}
        options={options}
    />)
}
